import { useSyncExternalStore } from "react";
import type { RoleCode, UserSummary } from "@/shared/api/types";
import { tokenStorage, userStorage } from "@/shared/api/apiClient";
import { clearTahtaDrawings } from "@/modules/tahta/tahtaDrawingStore";

interface AuthState {
  token: string | null;
  user: UserSummary | null;
}

let state: AuthState = {
  token: tokenStorage.get(),
  user: userStorage.get(),
};
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((l) => l());

export const setAuth = (token: string, user: UserSummary) => {
  tokenStorage.set(token);
  userStorage.set(user);
  state = { token, user };
  notify();
};

export const clearAuth = () => {
  tokenStorage.clear();
  clearTahtaDrawings();
  state = { token: null, user: null };
  notify();
};

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const getSnapshot = () => state;

export const useAuth = () => {
  const s = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return {
    token: s.token,
    user: s.user,
    isAuthenticated: !!s.token && !!s.user,
    hasRole: (role: RoleCode) => !!s.user?.roles.includes(role),
    hasAnyRole: (roles: RoleCode[]) => !!s.user?.roles.some((r) => roles.includes(r)),
    setAuth,
    clearAuth,
  };
};
